import { ColDef } from 'ag-grid-community';
import {
  ID_FIELD,
  NAME_FIELD,
  EMAIL_ID_FIELD,
  STATUS_FIELD,
  ACTIONS_FIELD,
} from './table-field-definitions';
import { ACTION_CONFIGS } from './table-action-configs';

export const DEFAULT_TABLE_COLUMNS: ColDef[] = [
  ID_FIELD,
  NAME_FIELD,
  EMAIL_ID_FIELD,
  STATUS_FIELD,
];

export const ACTION_COLUMN: ColDef = ACTIONS_FIELD;

export const TABLE_COLUMN_PRESETS = {
  DEFAULT: DEFAULT_TABLE_COLUMNS,

  withActions: (columns: ColDef[]) => [...columns, ACTION_COLUMN],

  getActions: (preset: keyof typeof ACTION_CONFIGS) =>
    ACTION_CONFIGS[preset] || ACTION_CONFIGS.DEFAULT,

  getPresetConfig: (preset: keyof typeof ACTION_CONFIGS) => ({
    columns: DEFAULT_TABLE_COLUMNS,
    actions: ACTION_CONFIGS[preset] || ACTION_CONFIGS.DEFAULT,
  }),
};
